import { render, staticRenderFns } from "./layout-tools-main.vue?vue&type=template&id=488875c6&scoped=true"
import script from "./layout-tools-main.vue?vue&type=script&lang=js"
export * from "./layout-tools-main.vue?vue&type=script&lang=js"
import style0 from "./layout-tools-main.vue?vue&type=style&index=0&id=488875c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488875c6",
  null
  
)

export default component.exports